import React from 'react'
import { Box, Flex, Text } from '@mindfulchefuk/design-system'
import toCurrency from '@mindfulchefuk/utils/toCurrency'
import plural from '@mindfulchefuk/utils/plural'
import { useChooseRecipesContext } from '@mindfulchefuk/onboarding/context/ChooseRecipesContext/ChooseRecipesContext'

export const OnboardingBasketFooterTotals = ({
  totalsData,
}: {
  totalsData: {
    total: string
    totalAfterDiscount: string
  }
}) => {
  const {
    maximumRecipesForPortion,
    minimumRecipesForPortion,
    selectedPortionCount,
    totalNumberOfRecipes,
  } = useChooseRecipesContext()

  const isDiscountApplied = parseFloat(totalsData.totalAfterDiscount) > 0

  const priceToCalculatePerPortionCost = isDiscountApplied
    ? totalsData.totalAfterDiscount
    : totalsData.total

  const pricePerPerson = totalsData
    ? parseFloat(priceToCalculatePerPortionCost) / selectedPortionCount
    : 0

  const recipesLabel = `${totalNumberOfRecipes} ${plural('recipe')(
    totalNumberOfRecipes
  )}`

  return (
    <Flex flexDirection="column">
      <Box>
        <Text as="span" variant="body-sm-500-caps" display={['none', 'inline']}>
          You added{' '}
        </Text>

        <Text as="span" variant="body-sm-500-caps">
          {`${recipesLabel} for ${selectedPortionCount} ${
            selectedPortionCount === 1 ? 'person' : 'people'
          }`}
        </Text>
      </Box>

      <Box>
        {isDiscountApplied && (
          <Text
            as="span"
            variant={['heading-xxs', 'heading-sm']}
            color="pepper-500"
            textDecoration="line-through"
            mr={2}
          >
            {toCurrency(parseFloat(totalsData.total))}
          </Text>
        )}

        <Text as="span" variant={['heading-xxs', 'heading-sm']} mr={2}>
          {isDiscountApplied
            ? toCurrency(parseFloat(totalsData.totalAfterDiscount))
            : toCurrency(parseFloat(totalsData.total))}
        </Text>

        {selectedPortionCount > 1 && (
          <Text as="span" variant="body-sm" color="pepper">
            ({toCurrency(pricePerPerson)} pp)
          </Text>
        )}

        <Text as="p" variant="body-sm" color="pepper">
          {totalNumberOfRecipes < minimumRecipesForPortion
            ? `Add ${minimumRecipesForPortion} to ${maximumRecipesForPortion} recipes`
            : `Add up to ${maximumRecipesForPortion} recipes`}
        </Text>
      </Box>
    </Flex>
  )
}
